import React, { useMemo, useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Spinner } from "react-bootstrap";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";

import "bootstrap/dist/css/bootstrap.min.css";

import ArticleCard from "../../shared/components/ArticleCard"; // ✅ ปรับ path ให้ตรงกับโปรเจคคุณ
import "../../shared/styles/CardSlideForm.css";
import "../../shared/styles/UtillitiesComponent.css";

import mock_ep_01 from "../../assets/mock_ep_01.png";
import mock_ep_02 from "../../assets/mock_ep_02.png";

export default function UpdateCourseMock() {
  const [loading] = useState(false);
  const [error] = useState("");

  // ✅ mock course list
  const coursesBase = useMemo(
    () => [
      {
        id: "c1",
        slug: "thaibar-1-79",
        cover: mock_ep_01,
        title: "เนติบัณฑิต 1/79",
        authorName: "ChicChic Team",
        updatedAt: "อัปเดต: ก.พ. 2026",
        level: "Beginner",
        duration: "3 ชั่วโมง",
        lessonsCount: 12,
        priceText: "฿990",
        categoryName: "เนติบัญฑิต",
        categorySlug: "เนติบัญฑิต",
        subCategoryName: "เนติบัญฑิต",
        subCategorySlug: "เนติบัญฑิต",
      },
      {
        id: "c2",
        slug: "lawyer-act",
        cover: mock_ep_02,
        title: "ทนายความ ภาคปฏิบัติ",
        authorName: "ChicChic Team",
        updatedAt: "อัปเดต: ม.ค. 2026",
        level: "Beginner",
        duration: "2 ชั่วโมง",
        lessonsCount: 9,
        priceText: "฿790",
        categoryName: "ทนายความ",
        categorySlug: "ทนายความ",
        subCategoryName: "ทนายความ",
        subCategorySlug: "ทนายความ",
      },
      {
        id: "c3",
        slug: "lawyer-principle",
        cover: mock_ep_01,
        title: "ทนายความ ภาคทฤษฎี",
        authorName: "ChicChic Team",
        updatedAt: "อัปเดต: ธ.ค. 2025",
        level: "Intermediate",
        duration: "2.5 ชั่วโมง",
        lessonsCount: 10,
        priceText: "฿890",
        categoryName: "ทนายความ",
        categorySlug: "ทนายความ",
        subCategoryName: "ทนายความ",
        subCategorySlug: "ทนายความ",
      },
      {
        id: "c4",
        slug: "attroney-01",
        cover: mock_ep_02,
        title: "อัยการ สนามใหญ่ 2569",
        authorName: "ChicChic Team",
        updatedAt: "อัปเดต: พ.ย. 2025",
        level: "Beginner",
        duration: "1.5 ชั่วโมง",
        lessonsCount: 7,
        priceText: "฿690",
        categoryName: "อัยการ",
        categorySlug: "อัยการ",
        subCategoryName: "อัยการ",
        subCategorySlug: "อัยการ",
      },
      {
        id: "c5",
        slug: "judge-01",
        cover: mock_ep_01,
        title: "ผู้ช่วยผู้พิพากษา สนามใหญ่ 2569",
        authorName: "ChicChic Team",
        updatedAt: "อัปเดต: ต.ค. 2025",
        level: "Intermediate",
        duration: "2 ชั่วโมง",
        lessonsCount: 8,
        priceText: "฿790",
        categoryName: "ผู้พิพากษา",
        categorySlug: "ผู้พิพากษา",
        subCategoryName: "ผู้พิพากษา",
        subCategorySlug: "ผู้พิพากษา",
      },
      {
        id: "c6",
        slug: "judge-01",
        cover: mock_ep_01,
        title: "ผู้ช่วยผู้พิพากษา สนามใหญ่ 2569",
        authorName: "ChicChic Team",
        updatedAt: "อัปเดต: ต.ค. 2025",
        level: "Intermediate",
        duration: "2 ชั่วโมง",
        lessonsCount: 8,
        priceText: "฿790",
        categoryName: "ผู้พิพากษา",
        categorySlug: "ผู้พิพากษา",
        subCategoryName: "ผู้พิพากษา",
        subCategorySlug: "ผู้พิพากษา",
      },
      {
        id: "c7",
        slug: "judge-01",
        cover: mock_ep_01,
        title: "ผู้ช่วยผู้พิพากษา สนามใหญ่ 2569",
        authorName: "ChicChic Team",
        updatedAt: "อัปเดต: ต.ค. 2025",
        level: "Intermediate",
        duration: "2 ชั่วโมง",
        lessonsCount: 8,
        priceText: "฿790",
        categoryName: "ผู้พิพากษา",
        categorySlug: "ผู้พิพากษา",
        subCategoryName: "ผู้พิพากษา",
        subCategorySlug: "ผู้พิพากษา",
      },
      {
        id: "c8",
        slug: "judge-01",
        cover: mock_ep_01,
        title: "ผู้ช่วยผู้พิพากษา สนามใหญ่ 2569",
        authorName: "ChicChic Team",
        updatedAt: "อัปเดต: ต.ค. 2025",
        level: "Intermediate",
        duration: "2 ชั่วโมง",
        lessonsCount: 8,
        priceText: "฿790",
        categoryName: "ผู้พิพากษา",
        categorySlug: "ผู้พิพากษา",
        subCategoryName: "ผู้พิพากษา",
        subCategorySlug: "ผู้พิพากษา",
      },
      {
        id: "c9",
        slug: "judge-01",
        cover: mock_ep_01,
        title: "ผู้ช่วยผู้พิพากษา สนามใหญ่ 2569",
        authorName: "ChicChic Team",
        updatedAt: "อัปเดต: ต.ค. 2025",
        level: "Intermediate",
        duration: "2 ชั่วโมง",
        lessonsCount: 8,
        priceText: "฿790",
        categoryName: "ผู้พิพากษา",
        categorySlug: "ผู้พิพากษา",
        subCategoryName: "ผู้พิพากษา",
        subCategorySlug: "ผู้พิพากษา",
      },
    ],
    []
  );

  // ✅ map course -> article shape (เพื่อใช้ ArticleCard)
  const mapCourseToArticleShape = (c) => {
    return {
      id: c.id,
      slug: c.slug,
      image: c.cover,
      title: c.title,
      author: c.authorName || "Encraft Team",
      date: c.updatedAt || "",

      // ArticleCard อาจใช้ readTime/views — ใส่ mock ให้ไม่พัง
      readTime: c.lessonsCount ?? 0, // ✅ ใช้จำนวนบทเรียนแทนชั่วคราว
      views: 0,

      // ตรงนี้เอาไว้ให้ badge/หมวดหมู่ไม่หลุด style
      subCategoryName: c.subCategoryName || "คอร์ส",
      subCategorySlug: c.subCategorySlug || "",
      categoryName: c.categoryName || "courses",
      categorySlug: c.categorySlug || "",

      // level เดิมของบทความคุณใช้ general/… → เราใส่ level ได้เลย (ถ้า ArticleCard แสดง)
    //   level: c.level || "Beginner",

      // เผื่อ ArticleCard อ่าน field อื่น
      tagSlugs: [],
    };
  };

  const [selectedSub, setSelectedSub] = useState("all");

  const subcategoryBadges = useMemo(() => {
    const map = new Map();
    coursesBase.forEach((c) => {
      if (!map.has(c.subCategorySlug)) map.set(c.subCategorySlug, c.subCategoryName);
    });
    return Array.from(map, ([slug, name]) => ({ slug, name }));
  }, [coursesBase]);

  const courses = useMemo(() => {
    if (selectedSub === "all") return coursesBase;
    return coursesBase.filter((c) => c.subCategorySlug === selectedSub);
  }, [coursesBase, selectedSub]);

  const row1 = courses.slice(0, 2);
  const row2 = courses.slice(2);

  // ✅ slide arrow logic (เหมือน UpdateArticle)
  const slideRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);
  const initialScrollRef = useRef(null);

  useEffect(() => {
    const el = slideRef.current;
    if (!el) return;

    el.scrollLeft = 0;
    initialScrollRef.current = null;

    const updateArrows = () => {
      const elNow = slideRef.current;
      if (!elNow) return;

      const { scrollLeft, scrollWidth, clientWidth } = elNow;
      if (initialScrollRef.current === null) initialScrollRef.current = scrollLeft;

      if (scrollWidth <= clientWidth + 1) {
        setCanScrollLeft(false);
        setCanScrollRight(false);
        return;
      }

      const base = initialScrollRef.current ?? 0;
      const atStart = scrollLeft <= base + 1;
      const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

      setCanScrollLeft(!atStart);
      setCanScrollRight(!atEnd);
    };

    updateArrows();
    el.addEventListener("scroll", updateArrows);
    window.addEventListener("resize", updateArrows);

    return () => {
      el.removeEventListener("scroll", updateArrows);
      window.removeEventListener("resize", updateArrows);
    };
  }, [row2.length, selectedSub]);

  const handleSlideNext = () => {
    const el = slideRef.current;
    if (!el) return;
    el.scrollBy({ left: el.clientWidth * 0.8, behavior: "smooth" });
    setHasInteracted(true);
  };

  const handleSlidePrev = () => {
    const el = slideRef.current;
    if (!el) return;
    el.scrollBy({ left: -el.clientWidth * 0.8, behavior: "smooth" });
    setHasInteracted(true);
  };

  return (
    <>
      <h3>
        <strong>คอร์สแนะนำ</strong>
      </h3>

      {loading && (
        <div className="text-center" style={{ marginTop: 100, marginBottom: 300 }}>
          <Spinner animation="border" role="status" />
        </div>
      )}

      {!loading && (
        <>
          {/* badge filter */}
          <div className="subcategory-scroll mb-0">
            <Button
              key="all"
              className={`border-1 btn-sm subcategory-btn ${selectedSub === "all" ? "active" : ""}`}
              variant="outline-dark"
              onClick={() => setSelectedSub("all")}
            >
              ทั้งหมด
            </Button>

            {subcategoryBadges.map((cat) => (
              <Button
                key={cat.slug}
                className={`border-1 btn-sm subcategory-btn ${selectedSub === cat.slug ? "active" : ""}`}
                variant="outline-dark"
                onClick={() => setSelectedSub(cat.slug)}
              >
                {cat.name}
              </Button>
            ))}
          </div>

          <br />
        </>
      )}

      {error && <div className="text-danger my-3">{error}</div>}

      {!loading && !error && (
        <>
          {/* row1: 2 cards */}
          <div className="row row-1 g-4 mb-4">
            {row1.map((c) => {
              const articleLike = mapCourseToArticleShape(c);
              return (
                <div key={c.id} className="col-lg-6 col-md-6 col-12">
                  <Link
                    to={`/courses/${c.slug || c.id}`}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <ArticleCard article={articleLike} />
                  </Link>
                </div>
              );
            })}
          </div>

          {/* row2: slide */}
          <div className="slide-wrapper">
            {hasInteracted && canScrollLeft && (
              <button
                type="button"
                className="slide-arrow slide-arrow-left"
                onClick={handleSlidePrev}
                aria-label="เลื่อนซ้าย"
              >
                <BsChevronLeft size={22} />
              </button>
            )}

            <div
              className="article-slide-container"
              ref={slideRef}
              onTouchStart={() => setHasInteracted(true)}
              onMouseDown={() => setHasInteracted(true)}
            >
              {row2.map((c) => {
                const articleLike = mapCourseToArticleShape(c);
                return (
                  <div key={c.id} className="slide-item">
                    <Link
                      to={`/courses/${c.slug || c.id}`}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <ArticleCard article={articleLike} />
                    </Link>
                  </div>
                );
              })}
            </div>

            {canScrollRight && (
              <button
                type="button"
                className="slide-arrow slide-arrow-right"
                onClick={handleSlideNext}
                aria-label="เลื่อนขวา"
              >
                <BsChevronRight size={22} />
              </button>
            )}
          </div>
        </>
      )}
    </>
  );
}

